import { motion } from "framer-motion";
import { LogOut, KeyRound, Store, CloudDownload, ShieldCheck } from "lucide-react";

const STEPS = [
  {
    key: "logout",
    icon: LogOut,
    title: "Выйдите из своего Apple ID",
    desc: "Откройте «Настройки» → ваше имя вверху → пролистайте вниз и нажмите «Выйти». Войти обратно вы сможете в любой момент.",
    img: "/assets/steps/signout.jpg",
    caption: "«Настройки» → ваш профиль → «Выйти»",
    safe: true,
  },
  {
    key: "login",
    icon: KeyRound,
    title: "Войдите выданными данными",
    desc: "Вставьте полученные логин и пароль только в разделе «Контент и покупки». iCloud, «Локатор» и пароль не меняйте.",
    img: "/assets/steps/signin.jpg",
    caption: "Введите выданные Apple ID и пароль",
  },
  {
    key: "purchases",
    icon: Store,
    title: "Откройте «Покупки» в App Store",
    desc: "Зайдите в App Store → ваш профиль вверху справа → «Покупки» / «Не на этом iPhone».",
    img: "/assets/steps/purchased.jpg",
    caption: "App Store → профиль → «Покупки»",
  },
  {
    key: "install",
    icon: CloudDownload,
    title: "Установите приложение",
    desc: "Найдите нужное приложение в списке и нажмите на облачко рядом с ним — начнётся загрузка на ваш iPhone.",
    img: "/assets/steps/download.jpg",
    caption: "Нажмите на облачко, чтобы скачать",
  },
];

function SafeNote() {
  return (
    <div
      data-testid="prosto-safe-note"
      className="flex items-start gap-3 rounded-2xl bg-emerald-50 border border-emerald-200 p-3.5"
    >
      <ShieldCheck size={20} className="shrink-0 text-emerald-600 mt-0.5" />
      <div className="text-[13px] leading-relaxed text-emerald-800">
        <b className="font-bold">Ничего не удалится.</b> При выходе из Apple ID ваши фото, контакты, заметки и все
        данные остаются на телефоне. Вы выходите только из App Store, а не из iCloud.
      </div>
    </div>
  );
}

export default function ProstoInstallGuide() {
  return (
    <div className="space-y-4" data-testid="prosto-install-guide">
      {STEPS.map((s, i) => {
        const Icon = s.icon;
        return (
          <motion.div
            key={s.key}
            data-testid={`prosto-install-step-${i + 1}`}
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-40px" }}
            transition={{ duration: 0.4, delay: i * 0.04 }}
            className="rounded-3xl bg-white border border-slate-200 p-4 shadow-sm"
          >
            <div className="flex items-center gap-3">
              <span className="shrink-0 grid place-items-center w-9 h-9 rounded-2xl bg-[#2F6BFF] text-white font-display font-extrabold text-base shadow-lg shadow-blue-500/25">
                {i + 1}
              </span>
              <div className="min-w-0 flex-1">
                <h3 className="font-display text-[15px] font-extrabold text-slate-900 leading-tight flex items-center gap-1.5">
                  <Icon size={16} className="text-[#2F6BFF] shrink-0" /> {s.title}
                </h3>
              </div>
            </div>

            <p className="mt-2.5 text-[13px] text-slate-600 leading-relaxed">{s.desc}</p>

            {s.safe && (
              <div className="mt-3">
                <SafeNote />
              </div>
            )}

            <div className="mt-3 rounded-2xl bg-gradient-to-b from-slate-900 to-slate-800 p-3 overflow-hidden">
              <img
                src={s.img}
                alt={s.title}
                loading="lazy"
                className="w-full max-h-[360px] object-contain mx-auto rounded-xl drop-shadow-2xl"
              />
            </div>
            <div className="mt-2 text-center text-xs text-slate-500">{s.caption}</div>
          </motion.div>
        );
      })}
    </div>
  );
}
